import { getCustomerMSW } from "api/generated/customer/customer.msw";
import { env } from "services/envService";
import { getAuthMSW } from "services/mockApiService/auth.msw";

export const mockedData =
  env.REACT_APP_STAGE === "test-e2e"
    ? [...getAuthMSW()]
    : [...getAuthMSW(), ...getCustomerMSW()];
